// Theme colors
export const theme = {
    light: {
      bg: "#ffffff",
      primary: "#2d2df1",
      secondary: "#001324",
      text: "#001324",
      chartBg: "#f9fafb",
      controlsBg: "#f3f4f6",
      tableBorder: "#e5e7eb",
      tableHeader: "#f3f4f6",
      tableRowEven: "#ffffff",
      tableRowOdd: "#f9fafb",
      buttonActive: "#2d2df1",
      buttonInactive: "#e5e7e9",
      buttonActiveText: "#ffffff",
      leaderboard1: "/leaderboard/Algorand-Developer Dashboard-1.svg",
      leaderboard2: "/leaderboard/Algorand-Developer Dashboard-2.svg",
      leaderboard3: "/leaderboard/Algorand-Developer Dashboard-3.svg",
    },
    dark: {
      bg: "#001324",
      primary: "#17cac6",
      secondary: "#ffffff",
      text: "#ffffff",
      chartBg: "#0a192f",
      controlsBg: "#0f2942",
      tableBorder: "#1e3a5f",
      tableHeader: "#0f2942",
      tableRowEven: "#0a192f",
      tableRowOdd: "#112240",
      buttonActive: "#17cac6",
      buttonInactive: "#99a1a7",
      buttonActiveText: "#001324",
      leaderboard1: "/leaderboard/Algorand-Developer Dashboard-1-DM.svg",
      leaderboard2: "/leaderboard/Algorand-Developer Dashboard-2-DM.svg",
      leaderboard3: "/leaderboard/Algorand-Developer Dashboard-3-DM.svg",
    }
  };

